import { Component } from '@angular/core';
import { HeaderComponent } from '../header/header.component';
import { AboutUsComponent } from '../about-us/about-us.component';
import { PartnerComponent } from '../partner/partner.component';
import { ArtistsComponent } from '../artists/artists.component';
import { ServicesComponent } from '../services/services.component';
import { FaqComponent } from '../faq/faq.component';
import { FooterComponent } from '../footer/footer.component';
import { MenuComponent } from '../menu/menu.component';

@Component({
  selector: 'app-main-page',
  standalone: true,
  imports: [HeaderComponent, AboutUsComponent, PartnerComponent, ArtistsComponent, ServicesComponent, FaqComponent, FooterComponent, MenuComponent],
  templateUrl: './main-page.component.html',
  styleUrl: './main-page.component.scss'
})
export class MainPageComponent {
  showMenu: boolean = false;

  changeMenuState(value: boolean) {
    this.showMenu = value;
  }

  scrollTo(id: string) {
    const element = document.getElementById(id);
    this.showMenu = false;

    setTimeout(() => element?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 1000);
  }
}
